var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeart03 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M9.03 1.504a2.507 2.507 0 0 0-3.547 0L5 1.987l-.483-.483A2.508 2.508 0 0 0 .97 5.05l.483.483L5 9.081l3.547-3.547.483-.483a2.507 2.507 0 0 0 0-3.547"
})));
export default SvgIconHeart03;